<script setup>
import { watch, ref } from 'vue';
import { storeToRefs } from "pinia";
import { Bar, Line } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement);

const props = defineProps(['chartData', 'chartOption', 'chartType', 'isLoading']);
const chartDatas = ref({
  labels: [],
  datasets: [
    {
      label: '',
      data: []
    }
  ]
});

const chartOptions = ref({
  responsive: true,
  maintainAspectRatio: false
})

watch([() => props.chartData], () => {
    chartDatas.value = {
        labels: props.chartData.labels,
        datasets: props.chartData.datasets
    }
})

</script>
<template>
    <div class="fv-content-wrapper">
      <div class="fv-chart-wrapper" v-loading="isLoading">
        <Bar :data="chartDatas" v-if="chartType == 'bar'" height="100" :options = "chartOption"/>
        <Line :data="chartDatas" v-if="chartType == 'line'" height="100" :options = "chartOption"/>
      </div>
    </div>
</template>